import User, {UserId} from 'records/User';
import {UserComment} from 'records/UserComment';
import moment, {Moment} from 'moment';
import {List} from 'immutable';
import {Data, Int, RecordProps} from '@store/@types/util';
import get from 'lodash/get';
import {FileUploadId} from 'records/CoachingReviewFileUpload';

export type Outcome = 'Successful' | 'Not Successful' | 'Unset';
export type Vote = 'Up' | 'Down' | undefined;
interface CallDetailsInterface {
  caller: any; // User like. Can pass to new User
  callerId: UserId;
  callStage: unknown;
  coachMe: boolean;
  company: string;
  contact: string;
  crmLink: string;
  description: string;
  durationSeconds: Int;
  id: FileUploadId;
  datetime: Moment;
  numberOfCallerScorecardResults: Int;
  numberOfScorecardResults: Int;
  numberOfVotesDown: Int;
  numberOfVotesUp: Int;
  outcome: Outcome;
  state: string;
  title: string;
  vote: Vote;
  tags: string[];
  comments: UserComment[];
  averageScore: number;

  // Deprecated.  Don't use.  Use datetime instead
  timestamp: Moment;

  // original search result model for any legacy code that relies on it
  searchResult: unknown;

  /**
   * TODO legacy property for CallCardStore.  Don't reuse
   * @deprecated
   */
  loading: boolean;
}

interface CallDetailsInput {
  date?: string;
  duration?: Int;
  templateLineOne?: string;
}

export default class CallDetails extends Data<CallDetailsInterface>({
  caller: undefined,
  callerId: undefined,
  callStage: undefined,
  coachMe: undefined,
  company: undefined,
  contact: undefined,
  crmLink: undefined,
  description: undefined,
  durationSeconds: undefined,
  id: undefined,
  datetime: undefined,
  numberOfCallerScorecardResults: undefined,
  numberOfScorecardResults: undefined,
  numberOfVotesDown: undefined,
  numberOfVotesUp: undefined,
  outcome: undefined,
  state: undefined,
  title: undefined,
  vote: undefined,
  tags: undefined,
  comments: undefined,
  averageScore: undefined,
  timestamp: undefined,
  searchResult: undefined,
  loading: undefined,
}) {
  constructor(object: RecordProps<CallDetailsInterface & CallDetailsInput> = {}) {
    const datetime = object.datetime || object.date;
    const metadataDescription = get(object, ['customContent', 'metadataLineOne']);

    super({
      ...object,
      durationSeconds: object.durationSeconds || object.duration,
      description: object.description || object.templateLineOne || metadataDescription,
      caller: object.caller ? new User(object.caller) : undefined,
      datetime: datetime ? moment(datetime) : undefined,
      timestamp: object.timestamp ? moment(object.timestamp) : undefined,
      comments: object.comments
        ? List(object.comments.map(comment => new UserComment(comment)))
        : undefined,
    });
  }

  isMetadataOnly() {
    return this.state && this.state.toLowerCase() === 'metadata_only';
  }
}
